import React from "react";
import { Grid, Typography } from "@material-ui/core";
import RefreshIcon from "@material-ui/icons/Cached";
import { DPButton } from "Components/DP";
import colors from "Styles/colors";
import { CheckmarkIcon } from "Components/Icons";
import useStyles from "./styles";

export function SuccessToastMessage() {
  const classes = useStyles();

  const onRefreshClick = () => {
    window.location.reload();
  };

  return (
    <Grid
      container
      direction="row"
      alignItems="center"
      spacing={4}
    >
      <Grid item className={classes.checkmarkWrapper}>
        <CheckmarkIcon fill={colors.white}/>
      </Grid>
      <Grid item xs container direction="column">
        <Grid item className={classes.successText}>Success!</Grid>
        <Grid item>
          <Typography>
            File Uploaded. We will email you once it has been approved.
          </Typography>
          <Typography>
            If you do not see the file listed below, refresh the page.
          </Typography>
        </Grid>
      </Grid>
      <Grid item>
        <DPButton size="large" variant="contained" onClick={onRefreshClick}>
          <RefreshIcon />
          Refresh
        </DPButton>
      </Grid>
    </Grid>
  );
}
